import {
    ToggleDropdown,
} from './Event';
import {
    closeDropdown,
    openDropdown,
} from './Dom';
import {REQUEST_CLASS} from '../../Library/HtmxRequestState';

/** @param {ToggleDropdown} event */
export const toggleDropdownHandler = event => {
    document.querySelectorAll('.dropdown-container').forEach(container => {
        if (container.classList.contains('active') && container !== event.dropdownContainer) {
            closeDropdown(container);
        }
    });

    if (!event.dropdownContainer.classList.contains('active')) {
        openDropdown(event.dropdownContainer);
    } else {
        closeDropdown(event.dropdownContainer);
    }
};

export const closeDropdownMenusHandler = () => {
    document.querySelectorAll('.dropdown-container.active').forEach(container => {
        closeDropdown(container);
    });
};

/**
 * @param {HTMLElement} target
 * @param {HTMLElement} dropdownContainer
 */
export const clickDropdownContainer = (target, dropdownContainer) => {
    const trigger = dropdownContainer.querySelector('.dropdown-trigger');

    if (trigger && (trigger.contains(target) || target === trigger)) {
        return document.dispatchEvent(new ToggleDropdown(dropdownContainer));
    }

    const menuItem = target.closest('.dropdown-menu li');
    if (menuItem) {
        const control = menuItem.querySelector('a, button');

        if (control && !control.contains(target)) {
            control.click();
        }

        if (control?.classList.contains(REQUEST_CLASS)) {
            return;
        }

        requestAnimationFrame(() => {
            closeDropdown(dropdownContainer);
        });
    }
};

export const closeRequestingDropdown = event => {
    const dropdownContainer = event.detail.elt.closest('.dropdown-container.active');

    if (dropdownContainer?.querySelector('.dropdown-menu')?.contains(event.detail.elt)) {
        closeDropdown(dropdownContainer);
    }
};
